import React from 'react'
import { useTranslation } from 'react-i18next'
import { HouseConsignment } from '../../house-consignment/models/types'
import HouseConsignmentsTableRowDetails from './HouseConsignmentsTableRowDetails'

interface HouseConsignmentsTableRowProps {
  houseConsignment: HouseConsignment
  houseSequenceNumber: number
  consignmentId: number
  consignmentConsignorName: string | null
  consignmentConsigneeName: string | null
  isExpanded: boolean
  onRowToggle: () => void
}

function HouseConsignmentsTableRow({
  houseConsignment,
  houseSequenceNumber,
  consignmentId,
  consignmentConsignorName,
  consignmentConsigneeName,
  isExpanded,
  onRowToggle,
}: Readonly<HouseConsignmentsTableRowProps>) {
  const { t } = useTranslation()

  // Fall back to the consignment-level (transit parties) trader when the house consignment has none.
  const consignorName = houseConsignment.consignor?.name ?? consignmentConsignorName
  const consigneeName = houseConsignment.consignee?.name ?? consignmentConsigneeName

  return (
    <div className="w-100 bg-body-tertiary border-bottom">
      <h4 className="mb-0 border-bottom">
        <button
          type="button"
          className="heading w-100 d-flex align-items-center justify-content-between p-1"
          data-bs-toggle="collapse"
          data-bs-target={`#${houseConsignment.id}`}
          aria-expanded={isExpanded}
          aria-controls={`${houseConsignment.id}`}
          onClick={onRowToggle}
        >
          <span className="flex-grow-1 text-start ps-1 hc-row-parties">
            <span className="hc-row-parties__sequence">
              <span>{t('declaration.p5.sequenceNumber')}</span>
              <span className="px-1">{(houseSequenceNumber ?? 0) + 1}</span>
            </span>

            {(consignorName || consigneeName) && (
              <span className="hc-row-parties__traders">
                {consignorName && (
                  <span className="hc-row-parties__trader">
                    <span className="text-body-secondary">{t('declaration.p5.consignor')}:</span>
                    <span className="hc-row-parties__value px-1">{consignorName}</span>
                  </span>
                )}
                {consignorName && consigneeName && (
                  <i className="fa fa-arrow-right text-body-secondary" aria-hidden="true" />
                )}
                {consigneeName && (
                  <span className="hc-row-parties__trader">
                    <span className="text-body-secondary">{t('declaration.p5.consignee')}:</span>
                    <span className="hc-row-parties__value px-1">{consigneeName}</span>
                  </span>
                )}
              </span>
            )}
          </span>

          <i className={`p-1 ms-2 fa ${isExpanded ? 'fa-chevron-up' : 'fa-chevron-down'}`} />
        </button>
      </h4>
      <div
        className={`bg-white collapse ${isExpanded ? 'show' : ''}`}
        id={`${houseConsignment.id}`}
      >
        {isExpanded && (
          <HouseConsignmentsTableRowDetails
            consignmentId={consignmentId}
            houseConsignment={houseConsignment}
          />
        )}
      </div>
    </div>

  )
}

export default HouseConsignmentsTableRow
